import {
  QUICK_DONATE_LOADING,
  QUICK_DONATE_SUCCESS,
  QUICK_DONATE_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listSingleItemService } from "services/listSingleItemService";
import { quickDonateUrl } from "api/apiUrls";

export const quickDonateActions = () => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: QUICK_DONATE_LOADING, payload: true });
    const response = await listSingleItemService(`${quickDonateUrl}`, "");

    dispatch({ type: QUICK_DONATE_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: QUICK_DONATE_FAILURE, payload: err });
  } finally {
    dispatch({ type: QUICK_DONATE_LOADING, payload: false });
  }
};
